export enum TableNameEnum {
        MyTeleVisits = 5206,
}
